import * as React from 'react';
import { Res, SaleDTO } from 'core/api';
import { Flex, Format } from 'core/ui';

export default function SaleControl({ sale }: { sale: SaleDTO; }): React.ReactNode {
	return <Flex.Vertical>
		<Flex.Item style={{ backgroundColor: '#000000', display: 'flex', justifyContent: 'center', alignItems: 'center' }} size='60px'>
			<h3 className='m-l-sm m-r-sm' style={{ color: '#FFFFFF' }}>
				{Res.Web.SCREEN_DISPLAY_LAST_SALE_CONTROL_LAST_SALE_LBL()} {sale.SerialNumber.SerieName}-{sale.SerialNumber.Number}
			</h3>
		</Flex.Item>
		<Flex.Item className='m-t-lg m-l-xl m-r-xl' size='*'>
			<div>
				<h1 className='font-bold m-l-lg'>
					{Res.Web.SCREEN_DISPLAY_LAST_SALE_CONTROL_AMOUNT_LBL()}
				</h1>
			</div>
			<div className='font-extra-bold text-right m-r-xl' style={{ fontSize: '4.5em', color: 'black' }}>
				{Format.asMoney(sale.NetAmount)}
			</div>


			<div>
				<h1 className='font-bold m-l-lg'>
					{Res.Web.SCREEN_DISPLAY_LAST_SALE_PAID_LBL()}
				</h1>
			</div>
			<div className='font-extra-bold text-right m-r-xl' style={{ fontSize: '4.5em', color: 'black' }}>
				{Format.asMoney(sale.PaidAmount)}
			</div>


			<div>
				<h1 className='font-bold m-l-lg'>
					{Res.Web.SCREEN_DISPLAY_LAST_SALE_CONTROL_CHANGE_AMOUNT_LBL()}
				</h1>
			</div>
			<div className='font-extra-bold text-right m-r-xl' style={{ fontSize: '4.5em', color: 'black' }}>
				{Format.asMoney(sale.ChangeAmount)}
			</div>

		</Flex.Item>
		<Flex.Item style={{ backgroundColor: '#000000' }} size='60px'> </Flex.Item>
	</Flex.Vertical>;
}
